import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27595 29857"
    {...props}
  >
    <path
      d="M21562 14492c4404-1327 5123-3993 5237-4943 234-1968-972-3814-2871-4385-914-277-3647-684-6624 2821 1050-4477-896-6433-1663-7007-1587-1186-3789-1063-5233 293-698 657-2417 2818-871 7149-3350-3148-6019-2439-6899-2063C814 7139-179 9105 275 11035c217 934 1230 3502 5757 4329-4404 1328-5123 3993-5237 4943-233 1968 972 3814 2871 4385 915 277 3647 684 6625-2820-1051 4476 896 6432 1663 7006 728 546 1586 814 2441 814 1006 0 2010-372 2792-1107 697-656 2417-2818 871-7149 3350 3148 6019 2442 6899 2063 1823-782 2817-2747 2363-4678-218-934-1231-3502-5758-4329zm3023 8139c-1956 840-5243-94-8603-5227-142-220-435-281-656-135-139 91-215 243-215 397 0 89 25 180 79 259 3360 5132 2899 8518 1347 9975-1110 1041-2801 1139-4019 224-1703-1275-2539-4587 224-10064 35-69 51-142 51-211 0-173-95-340-259-422-233-117-517-26-634 208-2767 5476-5928 6770-7966 6155-1457-439-2385-1855-2205-3370 253-2113 2704-4492 8827-4836 253-12 448-224 448-470v-28c-16-262-240-458-499-445-6126 344-8826-1748-9312-3820-347-1483 417-2994 1814-3593 1956-840 5243 94 8603 5227 145 217 438 281 656 135 139-91 214-243 214-397 0-89-25-180-78-259-3360-5132-2900-8518-1348-9975 1111-1041 2802-1136 4019-224 1704 1275 2540 4587-224 10064-34 69-50 142-50 211 0 173 95 340 259 423 233 116 517 25 634-209 2767-5476 5927-6770 7965-6154 1458 438 2385 1854 2206 3369-253 2113-2704 4492-8827 4836-253 13-448 224-448 470v28c16 262 240 461 498 445 6126-344 8827 1748 9313 3820 347 1483-417 2994-1814 3593z"
      style={{
        fill: "#1c1b17",
        // stroke: "#1c1b17",
        strokeWidth: 330.875,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
